type TViewType<T> = T & { viewTypes?: string | string[]}

export function extractViewTypeClassesFromProps<T>(props: TViewType<T>): string[] | undefined {
    let viewTypes = props.viewTypes;

    if (viewTypes && !Array.isArray(viewTypes)) {
        viewTypes = [viewTypes];
    }

    return viewTypes as string[];
}
